import { render, staticRenderFns } from "./dialLabel.vue?vue&type=template&id=53907d44&"
import script from "./dialLabel.vue?vue&type=script&lang=js&"
export * from "./dialLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports